import React, { createContext, useContext } from 'react';

const MainLayoutContext = createContext(undefined);

export const MainLayoutProvider = ({ children, value }) => {
    return <MainLayoutContext.Provider value={value}>{children}</MainLayoutContext.Provider>;
};

export const useMainLayoutContext = () => {
    const context = useContext(MainLayoutContext);
    if (context === undefined) {
        throw new Error('useMainLayoutContext 必須在 MainLayoutProvider 中使用');
    }
    return context;
};
